import { API_ENDPOINTS } from "constants";
import { useFetchData } from "./apiHooks";
import Avatar from "react-avatar";
import IconButtonWithTooltip from "components/buttons/IconButtonWithTooltip";
import { faCircleQuestion, faUser, faUsers } from "@fortawesome/free-solid-svg-icons";
import { useMemo } from "react";
import { useList } from "./useList";
import { OBJ } from "constants";

const todoAvatarColors = ["#212529", "#2a3137", "#3d4e5c", "#506981", "#5a7793"];
const TAB_ALL = 'all'
export const useUserOptions = (loadOnInit=true) => {
    const { list, isLoading, error, refetch } = useList(OBJ.USERS, null, null, loadOnInit, JSON.stringify({user_id_exclude: null}), 50);
    const users = list?.items

    // Helper to build user names
    const buildUserName = (user) => { 
        //if (!user) return "Select";
        const firstName = user.first_name || '';
        const lastName = user.last_name || '';
        return firstName || lastName ? `${firstName} ${lastName}`.trim() : `Unnamed, id: ${user.user_id}`;
    };

    // Generate user options
    const userOptions = () => {
        const options = users?.map(user => ({ 
            value: user.user_id, 
            label: buildUserName(user), 
            element: <Avatar style={{ cursor: "pointer" }} name={buildUserName(user)} size={32} round={true} /> 
        })) || [];

        options.unshift({
            value: null, 
            label: "Select",
            element: <IconButtonWithTooltip icon={faCircleQuestion} type='IconOnly' size="2xl"/>}
        ); // Add default option at the beginning
        return options;
    };

    const { tabItems } = useMemo(() => {
        if (!users) return { tabNames: [TAB_ALL], tabKeys: [TAB_ALL] };

        const items = users.map((user, index) => {return {
            id: user.user_id,
            label: `${user.first_name || ''} ${user.last_name || ''}`.trim() || `Unnamed, id: ${user.user_id}`,
            color: todoAvatarColors[index % todoAvatarColors.length],
            icon: faUser,
            type: "avatar",
        }});
        items.unshift({
            id: TAB_ALL, 
            label: TAB_ALL, 
            color: todoAvatarColors[items.length % todoAvatarColors.length], 
            icon: faUsers});

        return { tabItems: items };
    }, [users]);

    return { userOptions: userOptions(), tabItems, isLoading, error, refetch };
};

